'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('AccountCtrl', AccountCtrl).filter('htmlToPlaintext', function () {
    return function (text) {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  });
  AccountCtrl.$inject = ['$rootScope', '$scope', '$stateParams', 'countryGdprConfig', '$q', '$log', 'languageSvc', 'providerSvc', 'onboardingRouter', 'customSignupSvc', 'authenticationSvc', 'oAuthSvc', 'nameRegex', 'focus', 'NotifyingSvc', 'agreementsSvc', '$translate', '$timeout'];

  function AccountCtrl($rootScope, $scope, $stateParams, countryGdprConfig, $q, $log, languageSvc, providerSvc, onboardingRouter, customSignupSvc, authenticationSvc, oAuthSvc, nameRegex, focus, NotifyingSvc, agreementsSvc, $translate, $timeout) {
    $scope.isSubjectToGDPR = $stateParams.isSubjectToGDPR === true || $stateParams.isSubjectToGDPR === 'true';
    $scope.nameRegex = nameRegex;
    $scope.emailBlacklist = [];
    $scope.fields = [];
    $scope.user = {};
    $scope.countryGdprConfig = countryGdprConfig.getFromStorage();
    $scope.focusTitle = _focusTitle;
    $scope.save = _save;
    $scope.userSelectedLanguage = languageSvc.getLanguage();
    $scope.setUserSelectedLanguage = function (userSelectedLanguage) {
      $scope.userSelectedLanguage = userSelectedLanguage;
    };
    $scope.isTyping = false;

    $scope.checkTyping = function () {
      $scope.isTyping = true;
      if ($scope.typingTimer) {
        $timeout.cancel($scope.typingTimer);
      }
      $scope.typingTimer = $timeout(function () {
        $scope.isTyping = false;
      }, 2000); // 2 seconds delay to let the user finish typing
    };

    $scope.getTranslation = function (key) {
      return $translate.instant('onboarding.account.checkboxTerms.titles.' + key);
    };

    _activate();

    ///////////////////////////////

    function _activate() {
      var deferred = $q.defer(),
          provider = providerSvc.getProvider();

      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.GET_AGREEMENTS, true);

      languageSvc.getSupportedLanguages().then(function (supportedLanguages) {
        $scope.supportedLanguages = supportedLanguages;
      });

      if ($stateParams.oauthTicket) {
        $log.debug('attempting OAUTH authentication');
        oAuthSvc.oauthSetup($stateParams.oauthTicket).then(function (resp) {
          if (resp.type === 'LOGIN') {
            $log.debug('oauth successful - returning user.');
            onboardingRouter.goToNextStep(resp);
          } else {
            $log.debug('oauth successful - new user.');
            $log.debug(resp.signupView);
            $scope.user = resp.signupView;
            if (!provider) {
              providerSvc.setProvider({
                accessCode: resp.signupView.accessCode
              });
            }
            deferred.resolve(resp.signupView.accessCode);
          }
        });
      } else {
        deferred.resolve(provider.accessCode);
      }
      deferred.promise.then(function (ac) {
        if (!ac) {
          onboardingRouter.goToState('welcome');
          return;
        }
        $scope.user.accessCode = ac;
        if (ac === 'testfill') {
          _testFill();
        }
        agreementsSvc.getAgreementsByCode($scope.userSelectedLanguage, $scope.user.accessCode, true).then(function (agreements) {
          $scope.agreements = agreements;
        });
        // Check if need to show Last name field
        providerSvc.isFeatureEnabled('LAST_NAME').then(function (enabled) {
          $scope.showLastName = enabled;
        });
        // Get custom signup fields list by accessCode
        customSignupSvc.setupCustomSignup(ac).then(function () {
          $scope.fields = customSignupSvc.getCustomFields();
        });
      });
    }

    function _testFill() {
      $scope.user = {
        email: 'email-' + Math.random().toString(36).substring(7) + '@test.mystrength.com',
        password: 'Testing123',
        accessCode: 'testfill',
        alias: 'NotBatman3030',
        dateOfBirth: [1977, 3, 30],
        firstName: 'Bruce',
        lastName: 'Wayne',
        gender: 'MALE',
        sexAtBirth: 'MALE'
      };
      $scope.checkboxTerms = true;
      $scope.checkboxAge = true;
    }

    function _save() {
      if (!$scope.form.$valid) {
        // scroll to the title
        $('h2')[0].scrollIntoView(true);
        // if the form is not valid, mark the invalid fields
        angular.forEach($scope.form, function (formElement) {
          if (formElement && formElement.hasOwnProperty('$dirty')) {
            formElement.$dirty = true;
          }
        });
        return;
      }

      // add the organization to the user, if we have one
      var isMobileWebView = $stateParams.isMobileWebView ? true : false;
      var isSubjectToGDPR = $stateParams.isSubjectToGDPR ? true : false;
      var hasOptedInToMyStrengthEmails = $scope.checkboxMyStrengthEmailCommunication;
      var provider = providerSvc.getProvider();
      if (provider.organization) {
        $scope.user.organizationShortName = provider.organization;
      }
      $scope.user.referralVerificationTicket = provider.referralToken;
      $scope.user.language = $scope.userSelectedLanguage || navigator.language || 'en-US';
      // this prevents the button from being pressed twice
      $scope.saving = true;

      // Bundle up optional userMeta data
      var userMeta = {
        isMobileWebView: isMobileWebView,
        isSubjectToGDPR: isSubjectToGDPR,
        hasOptedInToMyStrengthEmails: hasOptedInToMyStrengthEmails
      };

      authenticationSvc.signup($scope.user, userMeta, $scope.fields, moment.tz.guess()).then(_saveComplete, _saveError)['finally'](function () {
        $scope.saving = false;
      });
    }

    function _saveComplete(response) {
      // Webview - set reauth token to $rootScope
      if ($stateParams.isMobileWebView) {
        var headers = angular.isFunction(response.headers) ? response.headers() : response.headers;

        if (headers['x-reauth-token']) {
          $rootScope.setReAuthToken(headers['x-reauth-token']);
        }
      }

      var userData = response.data;
      $scope.agreements.forEach(function (agreement) {
        agreement.userId = userData.response.id;
      });
      if ($scope.agreements.length) {
        agreementsSvc.saveAgreements($scope.agreements).then(function () {
          onboardingRouter.goToNextStep(_.merge({ response: response.data }, $stateParams));
        });
      } else {
        onboardingRouter.goToNextStep(_.merge({ response: response.data }, $stateParams));
      }
    }

    function _saveError(response) {
      if (response && response.data && response.data.hasOwnProperty('errorCode')) {
        var errorCode = response.data.errorCode,
            message = response.data.message;
        if (_.includes(errorCode, 'USER_ALREADY_EXISTS')) {
          $scope.emailBlacklist.push($scope.user.email);
          $scope.form.email.$setValidity('blacklist', false);
          $('h2')[0].scrollIntoView(true);
        } else {
          onboardingRouter.navigateError({
            message: message,
            contact: true
          });
        }
      } else {
        // got no message back
        onboardingRouter.navigateError({
          message: 'An error occurred',
          contact: true
        });
      }
    }

    function _focusTitle() {
      // Run by ng-include onload
      // Timeout needed to accommodate ng-include delay
      focus.byId('onboarding-title', 600);
      document.querySelector('#onboarding-title').focus();
    }
  }
})();